import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import { BatchModule } from 'src/modules/batch/module';
import { MaterialModule } from 'src/app/material.module';

import {FinanceDashboard} from './components/dashboard/component';

@NgModule({
  imports: [CommonModule, MaterialModule, BatchModule],
  declarations: [FinanceDashboard],
  exports: [FinanceDashboard],
})
export class FinanceAdminModule {}
